export const TESTING_REPORTS = {
  REPORT: 'testing-reports/report',
} as const
